import React, { useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '../../services/api';

function ResetPassword() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { uid, token } = useParams(); // Get params from URL

    const [formData, setFormData] = useState({ password: '', confirmPassword: '' });
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        if (formData.password !== formData.confirmPassword) {
            setError(t('Passwords do not match'));
            return;
        }

        setIsSubmitting(true);

        try {
            await api.post('/users/auth/password-reset/confirm/', {
                uid,
                token,
                password: formData.password
            });
            setSuccess(true);
            setTimeout(() => navigate('/login'), 3000); // Redirect after 3 seconds
        } catch (err) {
            const msg = err.response?.data?.detail || t('Invalid or expired token.');
            setError(msg);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (success) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-brand-dark text-white">
                <div className="p-8 bg-brand-dark rounded-lg shadow-md w-full max-w-md border border-green-500 text-center">
                    <h2 className="text-2xl font-bold mb-4 text-green-500">{t('Success!')}</h2>
                    <p>{t('Your password has been reset successfully.')}</p>
                    <p className="mt-4 text-gray-400">{t('Redirecting to login...')}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="flex items-center justify-center min-h-screen bg-brand-dark text-white">
            <div className="p-8 bg-brand-dark rounded-lg shadow-md w-full max-w-md border border-gray-700 hover:border-brand-orange">
                <h2 className="text-2xl font-bold text-center mb-6">{t('Set New Password')}</h2>
                
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block text-orange-400 font-light mb-1">
                            {t('New Password')}
                        </label>
                        <input
                            type="password"
                            required
                            value={formData.password}
                            onChange={(e) => setFormData({...formData, password: e.target.value})}
                            className="w-full px-3 py-2 border rounded-md bg-slate-700 border-slate-600 focus:outline-none focus:ring-2 focus:ring-orange-500"
                        />
                    </div>
                    <div className="mb-6">
                        <label className="block text-orange-400 font-light mb-1">
                            {t('Confirm Password')}
                        </label>
                        <input
                            type="password"
                            required
                            value={formData.confirmPassword}
                            onChange={(e) => setFormData({...formData, confirmPassword: e.target.value})}
                            className="w-full px-3 py-2 border rounded-md bg-slate-700 border-slate-600 focus:outline-none focus:ring-2 focus:ring-orange-500"
                        />
                    </div>

                    {error && <p className="text-red-500 text-center mb-4">{error}</p>}

                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className="w-full bg-orange-500 text-white py-2 rounded-md hover:bg-orange-600 transition-colors font-semibold"
                    >
                        {isSubmitting ? t('Updating...') : t('Reset Password')}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default ResetPassword;
